// Textos de inicio y movimientos: saldos, gráfica, productos, últimos movimientos, movimientos y pie. Claves: area.tema
export default {
  es: {
    // Pie de página
    'pie.derechos': 'Todos los derechos Reservados Panther 7',
    'pie.plataforma': 'Plataforma de Inversiones',

    // Tarjetas de saldos
    'saldos.cargando': 'Cargando información...',
    'saldos.valorCuenta': 'Valor de la cuenta',
    'saldos.disponible': 'Saldo disponible',
    'saldos.invertido': 'Monto invertido',
    'saldos.ganancias': 'Ganancias',
    'saldos.gananciasEsperadas': 'Ganancias esperadas',
    'saldos.ofertas': 'Mis ofertas',
    'saldos.depositoPendiente': 'Depósito pendiente',
    'saldos.misInversiones': 'Mis inversiones',
    'saldos.gananciasDia': 'Ganancias al día',
    'saldos.retenido': 'Saldo retenido',

    // Gráfica
    'grafica.sub': 'Todas sus inversiones',
    'grafica.titulo': 'Mis inversiones',
    'grafica.leyenda': 'Inversion efectuada correctamente a un monto de ',

    // Productos de inversión
    'productos.titulo': 'Productos de Inversión',
    'productos.escoge': 'Escoge tu oferta preferida',
    'productos.siguiente': 'Siguiente',
    'productos.atras': 'Atrás',
    'productos.invertir': 'Invertir',
    'productos.contrato': 'Contrato {nro}',
    'productos.pctOferta': '{pct}% de la oferta',
    'productos.montoDe': '{a} de {b} USDT',
    'productos.monto': '{n} USDT',
    'productos.dias': '{n} días',
    'productos.clasificacion': 'Clasificación',
    'productos.garantia': 'Garantía',
    'productos.participantes': 'Participantes',
    'productos.tasa': 'Tasa de interés',
    'productos.fin': 'Fecha de fin',
    'productos.plazo': 'Plazo total',
    'productos.restante': 'Tiempo restante',
    'productos.montoProyecto': 'Monto del proyecto',
    'productos.errCrear': 'Error al crear la inversión',
    'productos.vacioTitulo': 'Productos',
    'productos.vacioMsg': 'En breve se cargarán los productos',
    'productos.vacioPie': 'www.panther7.com | Proyecto de oferentes Panther 7',

    // Últimos movimientos (inicio)
    'movs.ultCargando': 'Cargando movimientos...',
    'movs.ultTituloD': 'Últimos Movimientos',
    'movs.ultTituloM': 'Últimos movimientos',
    'movs.ultResumen': 'Usted posee {n} movimientos en la cartera Panther 7 hasta la fecha',
    'movs.verTodos': 'Ver todos los movimientos',
    'movs.tipFecha': 'Fecha del movimiento',
    'movs.tipReferencia': 'Número de referencia',
    'movs.tipDetalle': 'Detalle del movimiento',
    'movs.tipMonto': 'Monto del movimiento',
    'movs.tipSaldo': 'Saldo total',
    'movs.hFecha': 'FECHA',
    'movs.hReferencia': 'REFERENCIA',
    'movs.hDescripcion': 'DESCRIPCIÓN',
    'movs.hMonto': 'MONTO',
    'movs.hSaldo': 'SALDO TOTAL',
    'movs.lFecha': 'Fecha:',
    'movs.lReferencia': 'Referencia:',
    'movs.lMonto': 'Monto:',
    'movs.lSaldo': 'Saldo Total:',
    'movs.lDescripcion': 'Descripción del movimiento:',
    'movs.vacioTitulo': 'Sin Movimientos',
    'movs.vacioMsg': 'Aún no tiene movimientos registrados en Panther 7',
    'movs.vacioPie': 'www.panther7.com | Movimientos registrados',

    // Pantalla Movimientos
    'movs.titulo': 'Movimientos',
    'movs.sub': 'Historial de tu wallet en USDT',
    'movs.exportar': 'Exportar CSV',
    'movs.preparando': 'Preparando…',
    'movs.archivo': 'movimientos-panther7',
    'movs.ingresos': 'Ingresos',
    'movs.egresos': 'Egresos',
    'movs.cantidad': 'Movimientos',
    'movs.todos': 'Todos',
    'movs.tipoAria': 'Tipo de movimiento',
    'movs.desde': 'Desde',
    'movs.hasta': 'Hasta',
    'movs.buscarPh': 'Buscar por descripción o referencia',
    'movs.buscarAria': 'Buscar movimientos',
    'movs.limpiar': 'Limpiar',
    'movs.colFecha': 'Fecha',
    'movs.colReferencia': 'Referencia',
    'movs.colDescripcion': 'Descripción',
    'movs.colMonto': 'Monto',
    'movs.colSaldo': 'Saldo',
    'movs.csvMonto': 'Monto (USDT)',
    'movs.csvSaldo': 'Saldo (USDT)',
    'movs.sinFiltros': 'Todavía no tienes movimientos.',
    'movs.sinResultados': 'No hay movimientos con esos filtros.',
    'movs.quitarFiltros': 'Quitar filtros',
    'movs.pagina': 'Página {p} de {n}',
    'movs.anterior': 'Anterior',
    'movs.siguiente': 'Siguiente',
    'movs.errCargar': 'No se pudieron cargar los movimientos.',
    'movs.errExportar': 'No se pudo exportar. Intenta de nuevo.',

    // Mensajes del servidor
    'srv:Inversión efectuada correctamente': 'Inversión efectuada correctamente',
    'srv:Cliente no posee saldo suficiente.': 'Cliente no posee saldo suficiente.',
    'srv: Cantidad excede el disponible para el proyecto': ' Cantidad excede el disponible para el proyecto',
    'srv:No se pudieron cargar los movimientos.': 'No se pudieron cargar los movimientos.',
    'srv:El campo amount debe ser al menos 50.': 'El campo amount debe ser al menos 50.',
    'srv:El campo amount es obligatorio.': 'El campo amount es obligatorio.',
    'srv:El campo amount debe ser un número.': 'El campo amount debe ser un número.',
  },
  en: {
    'pie.derechos': 'All rights reserved Panther7',
    'pie.plataforma': 'Investment Platform',

    'saldos.cargando': 'Loading information...',
    'saldos.valorCuenta': 'Account value',
    'saldos.disponible': 'Available balance',
    'saldos.invertido': 'Amount invested',
    'saldos.ganancias': 'Earnings',
    'saldos.gananciasEsperadas': 'Expected earnings',
    'saldos.ofertas': 'My offers',
    'saldos.depositoPendiente': 'Pending deposit',
    'saldos.misInversiones': 'My investments',
    'saldos.gananciasDia': 'Daily earnings',
    'saldos.retenido': 'Held balance',

    'grafica.sub': 'All your investments',
    'grafica.titulo': 'My investments',
    'grafica.leyenda': 'Investment successfully made for an amount of ',

    'productos.titulo': 'Investment Products',
    'productos.escoge': 'Choose your preferred offer',
    'productos.siguiente': 'Next',
    'productos.atras': 'Back',
    'productos.invertir': 'Invest',
    'productos.contrato': 'Contract {nro}',
    'productos.pctOferta': '{pct}% of the offer',
    'productos.montoDe': '{a} of {b} USDT',
    'productos.monto': '{n} USDT',
    'productos.dias': '{n} days',
    'productos.clasificacion': 'Rating',
    'productos.garantia': 'Guarantee',
    'productos.participantes': 'Participants',
    'productos.tasa': 'Interest rate',
    'productos.fin': 'End date',
    'productos.plazo': 'Total term',
    'productos.restante': 'Time remaining',
    'productos.montoProyecto': 'Project amount',
    'productos.errCrear': 'Error creating the investment',
    'productos.vacioTitulo': 'Products',
    'productos.vacioMsg': 'Products will be loaded shortly',
    'productos.vacioPie': 'www.panther7.com | Panther7 offeror project',

    'movs.ultCargando': 'Loading transactions...',
    'movs.ultTituloD': 'Latest Transactions',
    'movs.ultTituloM': 'Latest transactions',
    'movs.ultResumen': 'You have {n} transactions in your Panther7 wallet to date',
    'movs.verTodos': 'View all transactions',
    'movs.tipFecha': 'Transaction date',
    'movs.tipReferencia': 'Reference number',
    'movs.tipDetalle': 'Transaction details',
    'movs.tipMonto': 'Transaction amount',
    'movs.tipSaldo': 'Total balance',
    'movs.hFecha': 'DATE',
    'movs.hReferencia': 'REFERENCE',
    'movs.hDescripcion': 'DESCRIPTION',
    'movs.hMonto': 'AMOUNT',
    'movs.hSaldo': 'TOTAL BALANCE',
    'movs.lFecha': 'Date:',
    'movs.lReferencia': 'Reference:',
    'movs.lMonto': 'Amount:',
    'movs.lSaldo': 'Total Balance:',
    'movs.lDescripcion': 'Transaction description:',
    'movs.vacioTitulo': 'No Transactions',
    'movs.vacioMsg': 'You have no transactions recorded in Panther7 yet',
    'movs.vacioPie': 'www.panther7.com | Recorded transactions',

    'movs.titulo': 'Transactions',
    'movs.sub': 'Your wallet history in USDT',
    'movs.exportar': 'Export CSV',
    'movs.preparando': 'Preparing…',
    'movs.archivo': 'transactions-panther7',
    'movs.ingresos': 'Income',
    'movs.egresos': 'Expenses',
    'movs.cantidad': 'Transactions',
    'movs.todos': 'All',
    'movs.tipoAria': 'Transaction type',
    'movs.desde': 'From',
    'movs.hasta': 'To',
    'movs.buscarPh': 'Search by description or reference',
    'movs.buscarAria': 'Search transactions',
    'movs.limpiar': 'Clear',
    'movs.colFecha': 'Date',
    'movs.colReferencia': 'Reference',
    'movs.colDescripcion': 'Description',
    'movs.colMonto': 'Amount',
    'movs.colSaldo': 'Balance',
    'movs.csvMonto': 'Amount (USDT)',
    'movs.csvSaldo': 'Balance (USDT)',
    'movs.sinFiltros': 'You have no transactions yet.',
    'movs.sinResultados': 'No transactions match those filters.',
    'movs.quitarFiltros': 'Remove filters',
    'movs.pagina': 'Page {p} of {n}',
    'movs.anterior': 'Previous',
    'movs.siguiente': 'Next',
    'movs.errCargar': 'Your transactions could not be loaded.',
    'movs.errExportar': 'Could not export. Please try again.',

    'srv:Inversión efectuada correctamente': 'Investment completed successfully',
    'srv:Cliente no posee saldo suficiente.': 'You do not have enough balance.',
    'srv: Cantidad excede el disponible para el proyecto': 'The amount exceeds what is available for the project',
    'srv:No se pudieron cargar los movimientos.': 'Your transactions could not be loaded.',
    'srv:El campo amount debe ser al menos 50.': 'The amount must be at least 50 USDT.',
    'srv:El campo amount es obligatorio.': 'The amount is required.',
    'srv:El campo amount debe ser un número.': 'The amount must be a number.',
  },
  pt: {
    'pie.derechos': 'Todos os direitos reservados Panther7',
    'pie.plataforma': 'Plataforma de Investimentos',

    'saldos.cargando': 'Carregando informações...',
    'saldos.valorCuenta': 'Valor da conta',
    'saldos.disponible': 'Saldo disponível',
    'saldos.invertido': 'Valor investido',
    'saldos.ganancias': 'Ganhos',
    'saldos.gananciasEsperadas': 'Ganhos esperados',
    'saldos.ofertas': 'Minhas ofertas',
    'saldos.depositoPendiente': 'Depósito pendente',
    'saldos.misInversiones': 'Meus investimentos',
    'saldos.gananciasDia': 'Ganhos do dia',
    'saldos.retenido': 'Saldo retido',

    'grafica.sub': 'Todos os seus investimentos',
    'grafica.titulo': 'Meus investimentos',
    'grafica.leyenda': 'Investimento realizado com sucesso no valor de ',

    'productos.titulo': 'Produtos de Investimento',
    'productos.escoge': 'Escolha sua oferta preferida',
    'productos.siguiente': 'Próximo',
    'productos.atras': 'Voltar',
    'productos.invertir': 'Investir',
    'productos.contrato': 'Contrato {nro}',
    'productos.pctOferta': '{pct}% da oferta',
    'productos.montoDe': '{a} de {b} USDT',
    'productos.monto': '{n} USDT',
    'productos.dias': '{n} dias',
    'productos.clasificacion': 'Classificação',
    'productos.garantia': 'Garantia',
    'productos.participantes': 'Participantes',
    'productos.tasa': 'Taxa de juros',
    'productos.fin': 'Data de término',
    'productos.plazo': 'Prazo total',
    'productos.restante': 'Tempo restante',
    'productos.montoProyecto': 'Valor do projeto',
    'productos.errCrear': 'Erro ao criar o investimento',
    'productos.vacioTitulo': 'Produtos',
    'productos.vacioMsg': 'Os produtos serão carregados em breve',
    'productos.vacioPie': 'www.panther7.com | Projeto de ofertantes Panther7',

    'movs.ultCargando': 'Carregando movimentações...',
    'movs.ultTituloD': 'Últimas Movimentações',
    'movs.ultTituloM': 'Últimas movimentações',
    'movs.ultResumen': 'Você possui {n} movimentações na carteira Panther7 até o momento',
    'movs.verTodos': 'Ver todas as movimentações',
    'movs.tipFecha': 'Data da movimentação',
    'movs.tipReferencia': 'Número de referência',
    'movs.tipDetalle': 'Detalhe da movimentação',
    'movs.tipMonto': 'Valor da movimentação',
    'movs.tipSaldo': 'Saldo total',
    'movs.hFecha': 'DATA',
    'movs.hReferencia': 'REFERÊNCIA',
    'movs.hDescripcion': 'DESCRIÇÃO',
    'movs.hMonto': 'VALOR',
    'movs.hSaldo': 'SALDO TOTAL',
    'movs.lFecha': 'Data:',
    'movs.lReferencia': 'Referência:',
    'movs.lMonto': 'Valor:',
    'movs.lSaldo': 'Saldo Total:',
    'movs.lDescripcion': 'Descrição da movimentação:',
    'movs.vacioTitulo': 'Sem Movimentações',
    'movs.vacioMsg': 'Você ainda não tem movimentações registradas na Panther7',
    'movs.vacioPie': 'www.panther7.com | Movimentações registradas',

    'movs.titulo': 'Movimentações',
    'movs.sub': 'Histórico da sua carteira em USDT',
    'movs.exportar': 'Exportar CSV',
    'movs.preparando': 'Preparando…',
    'movs.archivo': 'movimentacoes-panther7',
    'movs.ingresos': 'Entradas',
    'movs.egresos': 'Saídas',
    'movs.cantidad': 'Movimentações',
    'movs.todos': 'Todos',
    'movs.tipoAria': 'Tipo de movimentação',
    'movs.desde': 'De',
    'movs.hasta': 'Até',
    'movs.buscarPh': 'Buscar por descrição ou referência',
    'movs.buscarAria': 'Buscar movimentações',
    'movs.limpiar': 'Limpar',
    'movs.colFecha': 'Data',
    'movs.colReferencia': 'Referência',
    'movs.colDescripcion': 'Descrição',
    'movs.colMonto': 'Valor',
    'movs.colSaldo': 'Saldo',
    'movs.csvMonto': 'Valor (USDT)',
    'movs.csvSaldo': 'Saldo (USDT)',
    'movs.sinFiltros': 'Você ainda não tem movimentações.',
    'movs.sinResultados': 'Não há movimentações com esses filtros.',
    'movs.quitarFiltros': 'Remover filtros',
    'movs.pagina': 'Página {p} de {n}',
    'movs.anterior': 'Anterior',
    'movs.siguiente': 'Próxima',
    'movs.errCargar': 'Não foi possível carregar as movimentações.',
    'movs.errExportar': 'Não foi possível exportar. Tente novamente.',

    'srv:Inversión efectuada correctamente': 'Investimento realizado com sucesso',
    'srv:Cliente no posee saldo suficiente.': 'Você não tem saldo suficiente.',
    'srv: Cantidad excede el disponible para el proyecto': 'O valor excede o disponível para o projeto',
    'srv:No se pudieron cargar los movimientos.': 'Não foi possível carregar as movimentações.',
    'srv:El campo amount debe ser al menos 50.': 'O valor deve ser de pelo menos 50 USDT.',
    'srv:El campo amount es obligatorio.': 'O valor é obrigatório.',
    'srv:El campo amount debe ser un número.': 'O valor deve ser um número.',
  },
};
